/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import * as l10n from './ClientIpAddressController.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @ngdoc controller
 * @name ClientIpAddressController
 */
class ClientIpAddressController {
    constructor($scope, l10nService) {
        $scope.l10nKeys = l10nKeys;
        l10nService.registerSourceBundles(dictionary);
    }
}

ClientIpAddressController.$inject = [
    '$scope',
    'l10nService',
];

angular.module('aviApp').controller('ClientIpAddressController', ClientIpAddressController);
